import styled from "styled-components"
import { BreakPoints, media } from "../../helpers/rwd"
import {
  LogoWrapperStyles,
  MenuButtonStyles, NavBarRwdWrapperDesktopStyles,
  NavBarRwdWrapperStyles
} from "./nav-bar-rwd-styles"

export const NavBarRwdWrapper = styled.div`
  display: none;
  ${media.max(BreakPoints.desktop)} {
    display: flex;
    justify-content: space-between;
    ${NavBarRwdWrapperDesktopStyles}
  }
  ${NavBarRwdWrapperStyles}
`

export const MenuButton = styled.div`
  display: flex;
  height: 100%;
  ${MenuButtonStyles}
`

export const LogoWrapper = styled.div`
  ${LogoWrapperStyles}
`
